// ######################################################################
// ###   Duplicate Flow Service in the json
// ######################################################################

import cloneDeep from 'lodash/cloneDeep';
import { getSubCategoryId } from './DictionaryManagementUtils';

const MAX_DUPLICATE_SERVICES = 9;
const ERROR_DUPLICATE_SERVICES = -1;

export function duplicateFlowService(
  jsonObj,
  duplicateService,
  replicatedName,
) {
  const replicatedDuplicationNumber = getAvailableIndex(jsonObj, duplicateService.sub_category);
  const subCategoryIdReplicate = `${duplicateService.sub_category}_${replicatedDuplicationNumber}`;
  const subCategoryIdDuplicate = getSubCategoryId(duplicateService);

  if (replicatedDuplicationNumber === ERROR_DUPLICATE_SERVICES) {
    return;
  }
  jsonObj.configurations.services[subCategoryIdReplicate] = cloneDeep(jsonObj.configurations.services[subCategoryIdDuplicate]);

  jsonObj.configurations.services[subCategoryIdReplicate].duplication_number = replicatedDuplicationNumber;
  jsonObj.configurations.services[subCategoryIdReplicate].name = replicatedName;

  addServiceToList(jsonObj, subCategoryIdReplicate);
  jsonObj.screensList = getDuplicateScreensList(jsonObj, duplicateService, replicatedDuplicationNumber);

  console.log(`add ${subCategoryIdDuplicate}`);
}

export function deleteDuplicatedFlowService(jsonObj, serviceToDelete) {
  if (serviceToDelete.duplication_number === 0) {
    console.log("can't delete original service");
    return;
  }
  const subCategoryId = getSubCategoryId(serviceToDelete);
  delete jsonObj.configurations.services[subCategoryId];
  removeServiceFromList(jsonObj, subCategoryId);
  removeDuplicatedScreensList(jsonObj, serviceToDelete);

  console.log(`remove ${subCategoryId}`);
}

const addServiceToList = (jsonObj, subCategoryIdReplicate) => {
  jsonObj.configurations.services.screens_ordering.push(subCategoryIdReplicate);
};

const removeServiceFromList = (jsonObj, keyToDelete) => {
  jsonObj.configurations.services.screens_ordering = jsonObj.configurations.services.screens_ordering.filter(
    (serviceKey) => serviceKey !== keyToDelete,
  );
};

const removeDuplicatedScreensList = (jsonObj, serviceToDelete) => {
  jsonObj.screensList = jsonObj.screensList.filter(
    (screen) => screen.sub_category !== serviceToDelete.sub_category
            || screen.duplication_number !== serviceToDelete.duplication_number,
  );
};

const getDuplicateScreensList = (
  jsonObj,
  duplicateService,
  duplication_number,
) => {
  const screen_index = 0;
  const newScreens = jsonObj.screensList
    .filter(
      (screen) => screen.sub_category === duplicateService.sub_category
                && screen.duplication_number === duplicateService.duplication_number,
    )
    .map((screen) => ({ ...screen, duplication_number, screen_index }));
  if (newScreens) {
    return jsonObj.screensList.concat(newScreens);
  }
  return jsonObj.screensList;
};

const getAvailableIndex = (jsonObj, sub_category) => {
  for (
    let duplication_number = 1;
    duplication_number < MAX_DUPLICATE_SERVICES;
    duplication_number += 1
  ) {
    const exists = jsonObj.configurations.services.screens_ordering
      .some((serviceKey) => serviceKey === getSubCategoryId({ sub_category, duplication_number }));

    if (!exists) {
      return duplication_number;
    }
  }
  return ERROR_DUPLICATE_SERVICES;
};
